import { get } from "./http-calls";

export const getTechnician = async () => {
    //Need to change endpoint

    // let res = await get('allTechnician', { useAuthToken: true });
    // return res;
};

export const getTechnicianJobs = async (TechnicianId) => {
    let res = await get(`TechnicianJobs/${TechnicianId}`, { useAuthToken: true });    
    return res;
};

function buildQueryString(params) {
    if (!params || typeof params !== 'object') {
        return '';
    }

    const queryStringParts = [];

    for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
            const value = params[key];
            if (value !== undefined && value !== null && value !== '') {
                const paramValue = typeof value === 'boolean' ? (value ? 'true' : 'false') : value;
                const encodedKey = encodeURIComponent(key);
                const encodedValue = encodeURIComponent(paramValue);
                if (encodedValue !== 'false') {
                    queryStringParts.push(`${encodedKey}=${encodedValue}`);
                }
            }
        }
    }

    if (queryStringParts.length > 0) {
        return '?' + queryStringParts.join('&');
    } else {
        return '';
    }
}

export const GetTechnitianDashHeaderRecords = async (ProcessID, IsHighPriority, IsFMOrWarranty, IsNightShift, IsBreakdown) => {
    const queryString = buildQueryString({
        ProcessID: ProcessID,
        IsHighPriority: IsHighPriority,
        IsFMOrWarranty: IsFMOrWarranty,
        IsNightShift: IsNightShift,
        IsBreakdown: IsBreakdown
    });

    let res = await get(`TechnicianJobs/GetTechnitianDashHeaderRecords${queryString}`, { useAuthToken: true });
    return res;
};